export const mbCommon = {
  mbcommon: {
    dataSheet: 'Data sheet',
    saveForLater: 'Save for later',
    readMore: '... read more',
    requestPrice: 'Request price',
    estimatedSubtotal: 'Estimated subtotal',
    priceOnRequest: 'Price on request',
    onRequest: 'On request',
    continue: 'Continue',
    back: 'Back',
    next: 'Next',
    mandatoryFields: '*mandatory fields',
    country: 'Country',
    dataSheets: 'Data sheets',
    yes: 'yes',
    no: 'no',
    item: 'item',
    items: 'items',
    continueShopping: 'Continue shopping',
    yourCart: 'Your cart',
    mandatory: '* mandatory',
    more: 'more',
    price: 'Price'

  },
  formValidationErrors: {
    required: 'This field is mandatory.',
    maxlength: 'Max. input length of 35 characters',
    maxUploadSizeExceeded: 'This file size is too large to upload. Please choose a file with max. 10MB.',
    pdfFileExtension: 'Please choose pdf as file extension.',
    pattern: 'This field should be an email address.'
  },
  addressesValidationErrors: {
    required: 'This field is mandatory.',
    maxlength: 'Max. input length of 35 characters'
  }
}

export const common = {
  httpHandlers: {
    validationErrors: {
      missing: {
        title: 'Salutation is mandatory.',
        firstName: 'First name is mandatory.',
        lastName: 'Last name is mandatory.',
        email: 'E-mail is mandatory.',
        companyName: 'Company/University is mandatory.',
        street: 'Company/University is mandatory.',
        houseNo: 'Street is mandatory.',
        zipCode: 'Postal code/Zip code is mandatory.',
        town: 'City is mandatory.',
        country: 'Country is mandatory.',
        region: 'State is mandatory.',
        vatId: 'VAT ID is mandatory.',
        countryIsocode: 'Country ISO code is mandatory.'
      },
      invalid: {
        title: 'Salutation is invalid.',
        firstName: 'First name is invalid.',
        lastName: 'Last name is invalid.',
        email: 'E-mail is invalid.',
        companyName: 'Company/University is invalid.',
        street: 'Company/University is invalid.',
        houseNo: 'Street is invalid.',
        zipCode: 'Postal code/Zip code is invalid.',
        town: 'City is invalid.',
        country: 'Country is invalid.',
        region: 'State is invalid.',
        vatId: 'VAT ID is invalid.',
        customerNumber: 'Customer number is invalid.',
        checkoutNotes: 'Maximum length is exceeded.',
        sessionCart: 'Cart is invalid.'
      }
    }
  },
  pageMetaResolver: {
    search: {
      mbTitle: 'Search | Miltenyi Biotec | {{countryName}}',
      description: 'Miltenyi Biotec is a global provider of biomedical research and cellular therapy products for cell isolation, flow cytometry, sample preparation, cell culture, molecular analysis, clinical application, and more'
    },
    cart: {
      mbTitle: 'Cart | Miltenyi Biotec | {{countryName}}'
    },
    checkout: {
      mbTitle: '{{title}} | {{countryName}}'
    },
    poUpload: {
      mbTitle: 'PO Upload | Miltenyi Biotec | {{countryName}}'
    },
    poConfirmation: {
      mbTitle: 'PO Upload Confirmation | Miltenyi Biotec | {{countryName}}'
    },
    myAccount: {
      mbTitle: '{{title}} | {{countryName}}'
    }
  },
  navigation: {
    login: 'Login',
    wishList: 'Wishlist',
    contact: 'Contact'
  }
}
